import { render, staticRenderFns } from "./Ecg.vue?vue&type=template&id=e16d89d6&scoped=true&"
import script from "./Ecg.vue?vue&type=script&lang=js&"
export * from "./Ecg.vue?vue&type=script&lang=js&"
import style0 from "./Ecg.vue?vue&type=style&index=0&id=e16d89d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16d89d6",
  null
  
)

export default component.exports